import { Genre } from './general';

export type CommonTrackMetadata = {
  genre: (Genre | undefined)[];
  bisacGenre: (Genre | undefined)[];
  wgsGenre: (Genre | undefined)[];
  titleLanguage: string;
  lyricsLanguage: string;
  explicit: Explicitness;
  pYear: string;
  pText: string;
  publisher: string[];
  instrumental: boolean;
  live: boolean;
  publicDomain: boolean;
  coverVersion: boolean;
  acapella: boolean;
  remastered: boolean;
  remasteredYear: string;
  noSpeaker: boolean;
};

export type OverallMetadata = CommonTrackMetadata & {
  appleDigitalMastered: boolean;
  appleEmail: string;
};

export type TrackMetadata = CommonTrackMetadata & {
  /** @deprecated Use Track.formatInfos.duration instead */
  duration?: number;
  snippetStart: string;
  snippetDuration: string;
  lyrics: string;
  aiUsageToggle: boolean;
  aiUsageLyrics: KIPolicies | '';
  aiUsageAudio: KIPolicies | '';
  aiUsageComposition: KIPolicies | '';
  aiUsageVideo: KIPolicies | '';
};

export enum Explicitness {
  EXPLICIT = 'EXPLICIT',
  CLEAN = 'CLEANED',
  NON_EXPLICIT = 'NOT_EXPLICIT',
}

export function isExplicitness(val: unknown): val is Explicitness {
  return val === Explicitness.EXPLICIT || val === Explicitness.CLEAN || val === Explicitness.NON_EXPLICIT;
}

export enum KIPolicies {
  NONE = 'NONE',
  PARTLY = 'PARTIAL',
  FULL = 'FULL',
}

export function isKIPolicy(val: unknown): val is KIPolicies {
  return val === KIPolicies.NONE || val === KIPolicies.PARTLY || val === KIPolicies.FULL;
}

export function getExplicitnessLabels(value: Explicitness) {
  switch (value) {
    case Explicitness.EXPLICIT:
      return $localize`:@@product-wizard.enum.explicit:Explicit`;
    case Explicitness.CLEAN:
      return $localize`:@@product-wizard.enum.clean:Cleaned`;
    case Explicitness.NON_EXPLICIT:
      return $localize`:@@product-wizard.enum.non-explicit:No explicit lyrics`;
  }
}

export function getExplicitOptions() {
  return [
    { value: Explicitness.EXPLICIT, label: getExplicitnessLabels(Explicitness.EXPLICIT) },
    { value: Explicitness.CLEAN, label: getExplicitnessLabels(Explicitness.CLEAN) },
    { value: Explicitness.NON_EXPLICIT, label: getExplicitnessLabels(Explicitness.NON_EXPLICIT) },
  ];
}

export function getKiPoliciesLabels(value: KIPolicies) {
  switch (value) {
    case KIPolicies.NONE:
      return $localize`:@@product-wizard.enum.kiPolicy-none:None`;
    case KIPolicies.PARTLY:
      return $localize`:@@product-wizard.enum.kiPolicy-partly:Partly`;
    case KIPolicies.FULL:
      return $localize`:@@product-wizard.enum.kiPolicy-full:Full`;
  }
}

export function getKiPoliciesOptions() {
  return [
    { value: KIPolicies.NONE, label: getKiPoliciesLabels(KIPolicies.NONE) },
    { value: KIPolicies.PARTLY, label: getKiPoliciesLabels(KIPolicies.PARTLY) },
    { value: KIPolicies.FULL, label: getKiPoliciesLabels(KIPolicies.FULL) },
  ];
}
